import React, { useEffect, useRef, useState } from 'react';
import {
  DEFAULT_DEV_TOKEN,
  DEV_TOKENS,
  DevToken,
} from '../apiClients/devTokens';
import { Button } from './shared';

const TokenSwitcher: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentTokenType, setCurrentTokenType] = useState<DevToken['key']>(
    (localStorage.getItem('debug_token_type') as DevToken['key']) ||
      DEFAULT_DEV_TOKEN.key
  );
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleTokenSwitch = (tokenType: DevToken['key']) => {
    const tokenData = DEV_TOKENS.find((token) => token.key === tokenType);

    // Update localStorage
    localStorage.setItem('debug_token', tokenData?.token || '');
    localStorage.setItem('debug_token_type', tokenType);

    // Update state
    setCurrentTokenType(tokenType);
    setIsOpen(false);

    // Reload page to apply new token
    window.location.reload();
  };

  // Only show in development
  if (process.env.REACT_APP_DEBUG_AUTH_ENABLED !== 'true') {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-50" ref={dropdownRef}>
      <div className="relative">
        <Button
          onClick={() => setIsOpen(!isOpen)}
          variant="outline"
          size="sm"
          className="bg-white/90 backdrop-blur-sm shadow-lg border-2 border-gray-300 hover:bg-white min-w-[160px] justify-between"
        >
          <span>
            {DEV_TOKENS.find((token) => token.key === currentTokenType)?.name}
          </span>
          <span
            className={`transition-transform ${isOpen ? 'rotate-180' : ''}`}
          >
            ▼
          </span>
        </Button>

        {isOpen && (
          <div className="absolute bottom-full right-0 mb-2 bg-white border border-gray-300 rounded-lg shadow-lg min-w-[160px]">
            {DEV_TOKENS.map((tokenData) => (
              <button
                key={tokenData.key}
                onClick={() => handleTokenSwitch(tokenData.key)}
                className={`w-full px-3 py-2 text-left hover:bg-gray-50 transition-colors ${
                  tokenData.key === currentTokenType
                    ? 'bg-blue-50 text-blue-700'
                    : 'text-gray-700'
                } ${tokenData.key === DEV_TOKENS[0].key ? 'rounded-t-lg' : ''} ${
                  tokenData.key === DEV_TOKENS[DEV_TOKENS.length - 1].key
                    ? 'rounded-b-lg'
                    : ''
                }`}
              >
                {tokenData.name}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default TokenSwitcher;
